import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Home from '../views/hou-shi/home.vue';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import {userData} from '@/store/userData';

const clientBase = '/hou-shi';

const routes: RouteRecordRaw[] = [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/home',
        meta: {
            title: '首页',
            noAuth: true,
        },
        component: Home,
    },
    {
        path: '/visit/dashboard',
        meta: {
            title: '访客统计',
            noAuth: true,
        },
        component: Home,
    },
    {
        path: '/level/random',
        meta: {
            title: '随机探索',
            noAuth: true,
        },
        component: Home,
    },
    {
        path: '/level/:id/edit',
        meta: {
            title: '编辑层级',
            noAuth: true,
        },
        component: Home,
    },
    {
        path: '/level/:id',
        meta: {
            title: '查看层级',
            noAuth: true,
        },
        component: Home,
    },
    {
        path: '/403',
        meta: {
            title: '没有权限',
            noAuth: true,
        },
        component: () => import('@/views/system/errors/403.vue'),
    },
    {
        path: '/404',
        meta: {
            title: '找不到页面',
            noAuth: true,
        },
        component: () => import('@/views/system/errors/404.vue'),
    },
    { path: '/:path(.*)', redirect: '/404' },
];

const router = createRouter({
    // history: createWebHashHistory(), // 路径带#
    history: createWebHistory(clientBase), // History 模式
    routes,
});

// 给默认可以看到的菜单
// export const defaultPermissions = ["ai_0", "bxcx_0", "gzt_0","aibsxz_0"];
export const defaultPermissions = [];

router.beforeEach((to, from, next) => {
    NProgress.start();
    const loginKey = sessionStorage.getItem('loginKey');
    const permiss = userData().permiss;
    // console.log(to.meta.permiss);
    if (to.meta.noAuth == true) {
        // 无需认证的页面
        next();
    } 
    else if (!loginKey) {
        // 未登录且需要认证
        if ( typeof to.meta.permiss == 'string' && defaultPermissions.includes(to.meta.permiss)) {
            userData().updatePermiss(defaultPermissions);
            next();
        }
        else {
            next('/403'); // 否则跳转无权限页
        }
    }
    else if (typeof to.meta.permiss == 'string' && !permiss.includes(to.meta.permiss)) {
        // 权限不足
        next('/403');
    } else {
        // 通过所有检查
        next();
    }
});

router.afterEach(() => {
    NProgress.done();
});

// 递归查找第一个叶子节点的index
const getFirstLeafNodeIndex = (nodes: any[]): string | null => {
  if (!nodes || !Array.isArray(nodes)) {
    return null;
  }

  for (const node of nodes) {
    // 如果节点没有children或children为空，则为叶子节点
    if (!node.children || node.children.length === 0) {
      return node.index;
    }
    
    // 如果有children，则递归查找
    const leafIndex = getFirstLeafNodeIndex(node.children);
    if (leafIndex !== null) {
      return leafIndex;
    }
  }
  
  return null;
};

// 递归提取所有叶子节点的index
const getAllLeafNodeIndexes = (nodes: any[]): string[] => {
  const indexes: string[] = [];
  
  if (!nodes || !Array.isArray(nodes)) {
    return indexes;
  }

  const traverse = (currentNodes: any[]) => {
    for (const node of currentNodes) {
      // 如果节点没有children或children为空，则为叶子节点
      if (!node.children || node.children.length === 0) {
        if (node.index) {
          indexes.push(node.index);
        }
      } else {
        // 如果有children，则递归遍历子节点
        traverse(node.children);
      }
    }
  };

  traverse(nodes);
  return indexes;
};

// 跳转到主页
export const gotoMainPage = () => {
    const currentPath = router.currentRoute.value.path;
    const defaultMainIndex = "/login";
    const permissArray = userData().permissArray;
    
    // 检查权限数组是否存在且非空
    if (!permissArray || permissArray.length === 0) {
        router.push('/403');
        return;
    }
    
    // 获取所有叶子节点的索引
    const allLeafIndexes = getAllLeafNodeIndexes(permissArray);
    
    // 检查是否有有效的叶子节点索引
    if (!allLeafIndexes || allLeafIndexes.length === 0) {
        router.push('/403');
        return;
    }

    // 如果当前界面是大的登录界面，就让其跳转到别的界面
    if( currentPath == '/login' ){
        // 优先跳转到默认主页面，否则跳转到第一个可用页面
        const targetRoute = allLeafIndexes.includes(defaultMainIndex) 
            ? defaultMainIndex 
            : allLeafIndexes[0];
        
        router.push(targetRoute);
    }

    // 检查当前路径是否为免认证路径
    const currentRoute = findRouteByPath(routes, currentPath);
    if (currentRoute && currentRoute.meta?.noAuth === true) {
        // router.push(currentPath);
        return;
    }
    
    // 检查当前路径是否在用户权限范围内
    if (allLeafIndexes.includes(currentPath)) {
        // router.push(currentPath);
        return;
    }
    
    // 优先跳转到默认主页面，否则跳转到第一个可用页面
    const targetRoute = allLeafIndexes.includes(defaultMainIndex) 
        ? defaultMainIndex 
        : allLeafIndexes[0];
    
    router.push(targetRoute);
};

// 辅助函数：根据路径查找路由配置
const findRouteByPath = (routes: RouteRecordRaw[], path: string): RouteRecordRaw | null => {
    for (const route of routes) {
        if (route.path === path) {
            return route;
        }
        
        // 检查子路由
        if (route.children) {
            const childRoute = findRouteByPath(route.children, path);
            if (childRoute) {
                return childRoute;
            }
        }
    }
    
    return null;
};

export default router;
